import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default{
    data(){
        return {
            customConfig: {
                storage: true, // 启用自定义列状态保存功能
                // 只对 storage 有效，用于重写默认的恢复自定义配置逻辑
                restoreStore: ({ id, storeData }) => {
                    return this.findCustomSetting(id).then((result) => {
                        return result; // 返回结果
                    });
                },
                // 只对 storage 有效，重写默认的保存方法  点击toolbar中确认按钮调用
                updateStore: ({ id, storeData }) => {
                    return this.saveCustomSetting(id, storeData);
                },

                checkMethod ({ column }) {
                    if (column.field === 'name') {
                        return false;
                    }
                    return true;
                }
            },
        }
     
    },
    methods: {
        async findCustomSetting(id) {
            try {
                let URL = `${url.getUserProfile}/${id}`;
                const res = await req.get(URL); // 等待请求完成
                if (res.data.code === 200) {
                    const obj = JSON.parse(res.data.data); // 解析数据
                    return obj; // 返回解析后的数据
                } else {
                } 
            } catch (error) {
            }
        },

        saveCustomSetting(id, storeData) {
            let URL = `${url.pushUserProfile}?gridName=${id}`;
            req.post(URL, storeData).then((res) => {
                if (res.data.code === 200) {
                } else {
                }
            })
        }
    },
}